import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { getRootContextPath } from '../../utils/context-path';

@customElement('as-menu-item')
export class MenuItem extends LitElement {
  public static styles = css`
    .menu-item {
      padding: calc(var(--spacer) * 0.8) var(--spacer);
      border-bottom: 1px solid var(--list-border);
      color: var(--body-color);
      display: block;
      text-decoration: none;

      &:hover {
        background-color: var(--list-hover);
      }

      &.active {
        background-color: var(--list-active);
      }
    }
  `;

  @property()
  public title!: string;
  @property()
  public href!: string;

  public render() {
    this.id = this.getDebugId();

    return html`
      <a class="${this.isSelected() ? 'menu-item active' : 'menu-item'}" href="${this.href}"> ${this.title} </a>
    `;
  }

  private getDebugId() {
    return 'menu-item' + this.href.replace(getRootContextPath(), '').replace(/\//g, '-');
  }

  private isSelected() {
    return window.location.pathname == this.href;
  }
}
